const ACCOMMODATION_TYPES = [
    { value: 1, label: "Hotel" },
    { value: 2, label: "Lodge" },
    { value: 3, label: "Guesthouse" },
    { value: 4, label: "Airbnb" },
];

export function getAccommodationLabelById(id: number) {
    const result = ACCOMMODATION_TYPES.find((item:any) => item.value === id);
    return result ? result.label : null;
}

export const AMENITIES = [
  { value: 1, label: "WiFi" },
  { value: 2, label: "Parking" },
  { value: 3, label: "Air Conditioning" },
  { value: 4, label: "Swimming Pool" },
  { value: 5, label: "Restaurant" },
  { value: 6, label: "Room Service" },
  { value: 7, label: "Gym/Fitness Center" },
  { value: 8, label: "Spa" },
  { value: 9, label: "Bar/Lounge" },
  { value: 10, label: "Pet Friendly" },
  { value: 11, label: "24/7 Reception" },
  { value: 12, label: "Laundry Service" },
  { value: 13, label: "Airport Shuttle" },
  { value: 14, label: "Conference Rooms" },
  { value: 15, label: "Hot Water" },
  { value: 16, label: "TV" },
  { value: 17, label: "Mini Bar" },
  { value: 18, label: "Balcony/Terrace" },
];

// export function getAmenityLabels(amenities: any) {
//   if (!amenities) return [];

//   const ids = Array.isArray(amenities)
//     ? amenities.map(Number)
//     : amenities.split(",").map(Number);

//   return AMENITIES
//     .filter((item) => ids.includes(item.value))
//     .map((item) => item.label);
// }
export function getAmenityLabels(amenities: any) {
  if (!amenities) return [];

  let ids: any[] = [];

  try {
    let parsed = amenities;

    // parse until it becomes array
    while (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }

    ids = Array.isArray(parsed) ? parsed.map(Number) : [];
  } catch (error) {
    ids = Array.isArray(amenities)
      ? amenities.map(Number)
      : String(amenities).split(',').map(Number);
  }

  return AMENITIES
    .filter(item => ids.includes(item.value))
    .map(item => item.label);
}

export const STATUS_MAP: Record<number, 'pending' | 'approved' | 'rejected'> = {
    1: 'pending',
    2: 'approved',
    3: 'rejected',
  };